<template>
  <v-layout row wrap id="filtersChips">
    <v-chip color="blue white--text" close v-for="item in countries" :key='item+"_country"' @input="removeCountriesFilter(item)" v-if="validateCountry(item)">
      <v-icon style="font-size: 16px" class='pr-2'>fas fa-map-marker-alt</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{getSelectedCountriesById(item).name}}
    </v-chip>
    <v-chip color="lime white--text" close v-for="item in states" :key='item+"_state"' @input="removeStatesFilter(item)" v-if="validateState(item)">
      <v-icon style="font-size: 16px" class='pr-2'>fas fa-map-marker-alt</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{getSelectedStatesById(item).name}}
    </v-chip>
    <v-chip color="deep-purple white--text" close v-for="item in cities" :key='item+"_city"' @input="removeCitiesFilter(item)" v-if="validateCity(item)">
      <v-icon style="font-size: 16px" class='pr-2'>fas fa-map-marker-alt</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{getSelectedCitiesById(item).name}}
    </v-chip>
    <v-chip color="pink lighten-2 white--text" close v-for="item in languages" :key='item+"_language"' @input="removeLanguagesFilter(item)" v-if="validateLanguage(item)">
      <v-icon style="font-size: 22px" class='pr-2'>fas fa-language</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{getSelectedLanguagesById(item).name}}
    </v-chip>
    <v-chip color="light-green white--text" close v-for="item in text" :key='item+"_text"' @input="removeTextFilter(item)">
      <v-icon style="font-size: 20px" class='pr-1'>text_fields</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="red white--text" close v-for="item in excludeTerm" :key='item+"_excludeTerm"' @input="removeExcludeTermFilter(item)">
      <v-icon style="font-size: 20px" class='pr-1'>close</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="light-blue lighten-2 white--text" close v-for="item in screenName" :key='item+"_screenName"' @input="removeScreenNameFilter(item)">
      <v-icon style="font-size: 16px" class='pr-2'>fas fa-at</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="pink white--text" close v-for="item in hashtag" :key='item+"_hashtag"' @input="removeHashtagFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fas fa-hashtag</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="pink lighten-2 white--text" close v-for="item in tweetType" :key='item+"_tweetType"' @input="removeTweetTypeFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fab fa-twitter</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item.replace('_', ' ')}}
    </v-chip>
    <v-chip color="red lighten-1 white--text" close v-for="item in sentiment" :key='item+"_sentiment"' @input="removeSentimentFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fas fa-heartbeat</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{(Number(item) === -2 ? 'Very Negative' : (Number(item) === -1 ? 'Negative' : (Number(item) === 0 ? 'Neutral' : (Number(item) === 1 ? 'Positive' : 'Very Positive'))))}}
    </v-chip>
    <v-chip color="black lighten-1 white--text" close v-for="item in entity" :key='item+"_entity"' @input="removeEntityFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fas fa-tags</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="black lighten-1 white--text" close v-for="item in entityType" :key='item+"_entityType"' @input="removeEntityTypeFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fas fa-tags</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip outline close v-for="item in emoji" :key='item' @input="removeEmojiFilter(item)" style="font-size: 20px;">
      {{item}}
    </v-chip>
    <v-chip color="purple lighten-2 white--text" close v-for="item in domain" :key='item+"_domain"' @input="removeDomainFilter(item)">
      <v-icon style="font-size: 16px" class='pr-2'>fas fa-globe</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="black lighten-1 white--text" close v-for="item in articleTopic" :key='item+"_article_topic"' @input="removeArticleTopicFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fas fa-tags</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="black lighten-1 white--text" close v-for="item in tweetTopic" :key='item+"_tweet_topic"' @input="removeTweetTopicFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fas fa-tags</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="black lighten-1 white--text" close v-for="item in topic" :key='item+"_topic"' @input="removeTopicFilter(item)">
      <v-icon style="font-size: 16px;" class='pr-2'>fas fa-tags</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{item}}
    </v-chip>
    <v-chip color="green lighten-2 white--text" close v-if="time" @input="removeTimeFilter()">
      <v-icon style="font-size: 16px" class='pr-2'>fas fa-clock</v-icon>
      <v-divider vertical dark style="background-color: white !important" class="mr-1"></v-divider>
      {{time}}
    </v-chip>
  </v-layout>
</template>

<style>
  #filtersChips .v-chip__content{
    padding-left: 8px
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters({getSelectedCountriesById: 'getSelectedCountriesById', getSelectedCountries: 'getSelectedCountries', getSelectedStatesById: 'getSelectedStatesById', getSelectedStates: 'getSelectedStates', getSelectedCitiesById: 'getSelectedCitiesById', getSelectedCities: 'getSelectedCities', getSelectedLanguagesById: 'getSelectedLanguagesById', getSelectedLanguages: 'getSelectedLanguages', getTimeFrame: 'getFromTime'}),
    time: {
      get () {
        if (!Array.isArray(this.filters.fromTime)) {
          var fromTime = Number(this.filters.fromTime.substr(0, this.filters.fromTime.indexOf(':')))
          var toTime = (fromTime + 1) + ':00:00'
          return 'From ' + this.filters.fromTime + ' to ' + toTime
        }
      },
      set (value) {
        this.setCustomFilters({fromTime: [], toTime: []})
      }
    },
    screenName: {
      get () {
        return this.filters.screenName
      },
      set (value) {
        this.setCustomFilters({screenName: value})
      }
    },
    text: {
      get () {
        return this.filters.text
      },
      set (value) {
        this.setCustomFilters({text: value})
      }
    },
    excludeTerm: {
      get () {
        return this.filters.excludeTerm
      },
      set (value) {
        this.setCustomFilters({excludeTerm: value})
      }
    },
    tweetType: {
      get () {
        return this.filters.tweetType
      },
      set (value) {
        this.setCustomFilters({tweetType: value})
      }
    },
    sentiment: {
      get () {
        return this.filters.sentiment
      },
      set (value) {
        this.setCustomFilters({sentiment: value})
      }
    },
    articleTopic: {
      get () {
        return this.filters.articleTopic
      },
      set (value) {
        this.setCustomFilters({articleTopic: value})
      }
    },
    tweetTopic: {
      get () {
        return this.filters.tweetTopic
      },
      set (value) {
        this.setCustomFilters({tweetTopic: value})
      }
    },
    topic: {
      get () {
        return this.filters.topic
      },
      set (value) {
        this.setCustomFilters({topic: value})
      }
    },
    entity: {
      get () {
        return this.filters.entity
      },
      set (value) {
        this.setCustomFilters({entity: value})
      }
    },
    entityType: {
      get () {
        return this.filters.entityType
      },
      set (value) {
        this.setCustomFilters({entityType: value})
      }
    },
    hashtag: {
      get () {
        return this.filters.hashtag
      },
      set (value) {
        this.setCustomFilters({hashtag: value})
      }
    },
    emoji: {
      get () {
        return this.filters.emoji
      },
      set (value) {
        this.setCustomFilters({emoji: value})
      }
    },
    domain: {
      get () {
        return this.filters.domain
      },
      set (value) {
        this.setCustomFilters({domain: value})
      }
    },
    countries: {
      get () {
        if (this.getSelectedCountries.length > 0) {
          return this.filters.countryId
        } else {
          return []
        }
      },
      set (value) {
        this.setCustomFilters({countryId: value})
      }
    },
    states: {
      get () {
        if (this.getSelectedStates.length > 0) {
          return this.filters.stateId
        } else {
          return []
        }
      },
      set (value) {
        this.setCustomFilters({stateId: value})
      }
    },
    cities: {
      get () {
        if (this.getSelectedCities.length > 0) {
          return this.filters.cityId
        } else {
          return []
        }
      },
      set (value) {
        this.setCustomFilters({cityId: value})
      }
    },
    languages: {
      get () {
        if (this.getSelectedLanguages.length > 0) {
          return this.filters.languageId
        } else {
          return []
        }
      },
      set (value) {
        this.setCustomFilters({languageId: value})
      }
    }
  },
  methods: {
    ...mapMutations('filters', ['setCustomFilters']),
    validateCountry: function (item) {
      return (this.getSelectedCountriesById(item) !== undefined)
    },
    validateState: function (item) {
      return (this.getSelectedStatesById(item) !== undefined)
    },
    validateCity: function (item) {
      return (this.getSelectedCitiesById(item) !== undefined)
    },
    validateLanguage: function (item) {
      return (this.getSelectedLanguagesById(item) !== undefined)
    },
    removeTimeFilter: function () {
      this.setCustomFilters({fromTime: [], toTime: []})
    },
    removeScreenNameFilter: function (val) {
      let temp = this.screenName.slice()
      temp = temp.filter(v => v !== val)
      this.screenName = temp
    },
    removeTextFilter: function (val) {
      let temp = this.text.slice()
      temp = temp.filter(v => v !== val)
      this.text = temp
    },
    removeExcludeTermFilter: function (val) {
      let temp = this.excludeTerm.slice()
      temp = temp.filter(v => v !== val)
      this.excludeTerm = temp
    },
    removeTweetTypeFilter: function (val) {
      let temp = this.tweetType.slice()
      temp = temp.filter(v => v !== val)
      this.tweetType = temp
    },
    removeSentimentFilter: function (val) {
      let temp = this.sentiment.slice()
      temp = temp.filter(v => v !== val)
      this.sentiment = temp
    },
    removeArticleTopicFilter: function (val) {
      let temp = this.articleTopic.slice()
      temp = temp.filter(v => v !== val)
      this.articleTopic = temp
    },
    removeTweetTopicFilter: function (val) {
      let temp = this.tweetTopic.slice()
      temp = temp.filter(v => v !== val)
      this.tweetTopic = temp
    },
    removeTopicFilter: function (val) {
      let temp = this.topic.slice()
      temp = temp.filter(v => v !== val)
      this.topic = temp
    },
    removeEntityFilter: function (val) {
      let temp = this.entity.slice()
      temp = temp.filter(v => v !== val)
      this.entity = temp
    },
    removeEntityTypeFilter: function (val) {
      let temp = this.entityType.slice()
      temp = temp.filter(v => v !== val)
      this.entityType = temp
    },
    removeHashtagFilter: function (val) {
      let temp = this.hashtag.slice()
      temp = temp.filter(v => v !== val)
      this.hashtag = temp
    },
    removeEmojiFilter: function (val) {
      let temp = this.emoji.slice()
      temp = temp.filter(v => v !== val)
      this.emoji = temp
    },
    removeDomainFilter: function (val) {
      let temp = this.domain.slice()
      temp = temp.filter(v => v !== val)
      this.domain = temp
    },
    removeCountriesFilter: function (id) {
      let temp = this.countries.slice()
      temp = temp.filter(v => v !== id)
      this.countries = temp
    },
    removeStatesFilter: function (id) {
      let temp = this.states.slice()
      temp = temp.filter(v => v !== id)
      this.states = temp
    },
    removeCitiesFilter: function (id) {
      let temp = this.cities.slice()
      temp = temp.filter(v => v !== id)
      this.cities = temp
    },
    removeLanguagesFilter: function (id) {
      let temp = this.languages.slice()
      temp = temp.filter(v => v !== id)
      this.languages = temp
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Filters.vue